import React, { useEffect, useState } from "react";
import logo from "../../../assets/logo.svg";
import logopng from "../../../assets/NewLogo2.png";
import { useNavigate, useLocation } from "react-router-dom";
import { useUserContext } from "../../../context/MemorialContext";
import { updateHasPaid } from "./utils";
import "../about/about.css";

function Success() {
  const navigate = useNavigate();
  const location = useLocation();
  const [Address, setAddress] = useState("");
  const [packageType, setPackageType] = useState(null);

  const { user, setUser, fetchUser } = useUserContext();

  // Extrae ?package=2 del URL
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const pkg = searchParams.get("package");
    if (pkg) {
      localStorage.setItem("package", pkg);
      setPackageType(pkg);
    }
  }, [location.search]);

  // Actualiza usuario después del pago
  useEffect(() => {
    if (user) {
      updateHasPaid(user, true, setUser);
      fetchUser();
    }
  }, []);

  const handleContinue = async () => {
    try {
      if (localStorage.getItem("package") === "2") {
        const token = localStorage.getItem("token"); // Asegúrate que esté guardado al logear
        await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/user/shipping-address`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ address: Address }),
        });

        localStorage.setItem("Address", Address);
      }

      //localStorage.removeItem("package"); // ✅ limpiar después de usar
      navigate("/creatememorial");
    } catch (err) {
      console.error("Failed to save shipping address:", err);
    }
  };

  return (
    <div className="aboutpage">
      <div className="ab-top">
        <img
          src={logopng}
          style={{ maxWidth: "300px", minWidth: "200px" }}
          alt="Logo"
        />
        <div className="content1">
          <p className="tp">Payment Successful</p>
          <p className="btm">
            At willalwaysloveu, we provide a shared, easily-accessible virtual space where family members and friends can pay homage to a special life while helping each other heal by sharing their feelings, warm memories, and words of support.
          </p>

          <div className="addressWrapper">
            {packageType === "2" && (
              <div>
                <p className="tp">Shipping Address for Frame</p>
                <textarea
                  rows={5}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </div>
            )}

            <button className="memobtn" onClick={handleContinue}>
              Continue
            </button>
          </div>
        </div>
      </div>

      <div className="triagnle"></div>
      <div className="ab-bottom"></div>
    </div>
  );
}

export default Success;

